<ng-container *ngIf="scorecard?.Sponsor?.SponsorImage">
  <div class="sponsor-img-text">
    <p class="sponsor-label">{{ 'fgbcl.scorecard.sponsor.presented.by.label' | translate }}</p>
    <a [attr.href]="scorecard?.Sponsor?.SponsorLink || null" [attr.target]="scorecard?.Sponsor?.SponsorLink ? '_blank' : null">
      <img class="sponsor-img" [src]="scorecard.Sponsor.SponsorImage | contentImage : '30'" />
    </a>
  </div>
</ng-container>
